import union from 'lodash/union';

/** @module utils/determineProductOfferings */

/**
 * Parameters for determining available product offerings.
 */
interface DetermineProductOfferingsParams {
    filteredFacilities: Array<{
        productOfferings: string[];
    }>;
}

/**
 * Result indicating whether specific product offerings are enabled.
 */
interface ProductOfferings {
    transientEnabled: boolean;
    monthlyEnabled: boolean;
    airportEnabled: boolean;
    eventEnabled: boolean;
}

/**
 * Determines the available product offerings across a set of facilities.
 *
 * @param {DetermineProductOfferingsParams} params - The input parameters.
 * @returns {ProductOfferings} An object indicating whether specific product offerings are enabled.
 */
const determineProductOfferings = ({
    filteredFacilities,
}: DetermineProductOfferingsParams): ProductOfferings => {
    const productOfferingsArray = filteredFacilities.reduce<string[]>(
        (offerings, facility) => {
            const {productOfferings} = facility;

            return union(productOfferings, offerings);
        },
        []
    );

    return {
        transientEnabled: productOfferingsArray.includes('transient'),
        monthlyEnabled: productOfferingsArray.includes('monthly'),
        airportEnabled: productOfferingsArray.includes('airport'),
        eventEnabled: productOfferingsArray.includes('events'),
    };
};

export default determineProductOfferings;
